import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import reducers from "reducers";
// import "i18n";
import App from "components/App";
import { BrowserRouter } from "react-router-dom";
// import "css/fullcalendar.min.css";
// import "css/style.css";

import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { GoogleReCaptcha } from "util/constant";

const AddCaptcha = () => {
  const elementId = "google-recaptcha";
  const captchaExist = document.getElementById(elementId);
  if (!captchaExist) {
    const src = `https://www.google.com/recaptcha/api.js?render=${GoogleReCaptcha.SiteKey}`;
    const script = document.createElement("script");
    script.id = elementId;
    script.src = src;
    document.head.appendChild(script);
  }
};

AddCaptcha();


let currentLang = localStorage.getItem("i18nextLng")
  ? localStorage.getItem("i18nextLng")
  : "tr-TR";

i18n
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      supportedLngs: ["tr-TR","en-US", "ar-AE","de-DE","fr-FR","es-ES","ru-RU"],
      fallbackLng: currentLang,
      debug: false,

      interpolation: {
        escapeValue: false,
      },
      react: {
        wait: true,
      },
    },
    startApp
  );

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

// startApp();

function startApp() {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,
    document.querySelector("#root")
  );
}
